import { useEffect, useState } from "react";

// The active section is the last one whose top has crossed a line ~35% down
// the viewport. At the very bottom of the page the last section wins, so
// short final sections still light up. Clicking a nav link pins that section
// until the user scrolls by hand, since short sections near the bottom can't
// scroll up to the line.
const useActiveSection = (ids) => {
  const [active, setActive] = useState(ids[0] || null);

  useEffect(() => {
    let raf = 0;
    let pinned = null;
    const update = () => {
      raf = 0;
      const line = window.innerHeight * 0.35;
      const atBottom =
        window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      let current = ids[0] || null;
      if (pinned) {
        current = pinned;
      } else if (atBottom) {
        current = ids[ids.length - 1];
      } else {
        ids.forEach((id) => {
          const node = document.getElementById(id);
          if (node && node.getBoundingClientRect().top <= line) current = id;
        });
      }
      setActive((prev) => (prev === current ? prev : current));
    };
    const onScroll = () => {
      if (!raf) raf = window.requestAnimationFrame(update);
    };
    const onClick = (event) => {
      const link = event.target.closest && event.target.closest('a[href^="#"]');
      const id = link && link.getAttribute("href").slice(1);
      if (id && ids.includes(id)) {
        pinned = id;
        update();
      }
    };
    const release = () => {
      if (!pinned) return;
      pinned = null;
      onScroll();
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    document.addEventListener("click", onClick);
    window.addEventListener("wheel", release, { passive: true });
    window.addEventListener("touchmove", release, { passive: true });
    window.addEventListener("keydown", release);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      document.removeEventListener("click", onClick);
      window.removeEventListener("wheel", release);
      window.removeEventListener("touchmove", release);
      window.removeEventListener("keydown", release);
      if (raf) window.cancelAnimationFrame(raf);
    };
  }, [ids]);

  return active;
};

export default useActiveSection;
